import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Bookit-dark-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-11b6b8a0")

_pushScopeId("data-v-11b6b8a0")
const _hoisted_1 = { class: "wrapper fadeInDown p-0 pt-lg-4" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group position-relative" }
const _hoisted_4 = {
  type: "submit",
  class: "bookit-button w-100"
}
const _hoisted_5 = { class: "nav-links-block" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_9 = {
  type: "submit",
  class: "bookit-button w-100"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_LanguageSwitcher),
    _createVNode("div", _hoisted_1, [
      (!$setup.forgotPassword)
        ? (_openBlock(), _createBlock("form", {
            key: 0,
            class: "loginForm",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_2, [
              _createVNode("label", null, _toDisplayString(_ctx.$t('login.username')), 1),
              _withDirectives(_createVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.Username = $event)),
                class: "form-control form-control-lg",
                placeholder: _ctx.$t('login.username')
              }, null, 8, ["placeholder"]), [
                [_vModelText, $setup.Username]
              ])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("label", null, _toDisplayString(_ctx.$t('login.password')), 1),
              _withDirectives(_createVNode("input", {
                type: $setup.passwordFieldType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.Password = $event)),
                class: "form-control form-control-lg input-password",
                placeholder: "********"
              }, null, 8, ["type"]), [
                [_vModelDynamic, $setup.Password]
              ]),
              _createVNode("i", {
                class: ["icon-f fs-28 hide-show-pass", $setup.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.passwordFieldType = $setup.passwordFieldType === 'password' ? 'text' : 'password'))
              }, null, 2)
            ]),
            _createVNode("button", _hoisted_4, _toDisplayString(_ctx.$t('login.signIn')), 1),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, { to: { name: 'registration' } }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.createAccount')), 1)
                ]),
                _: 1
              }),
              _createVNode("span", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.forgotPassword = true)),
                class: "pointer"
              }, _toDisplayString(_ctx.$t('login.iForgotMyPassword')), 1)
            ])
          ], 32))
        : (_openBlock(), _createBlock("form", {
            key: 1,
            class: "loginForm mt-5",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.resetPassword($event)), ["prevent"])),
            novalidate: ""
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode("label", null, _toDisplayString(_ctx.$t('login.forgotPassword')), 1),
              _withDirectives(_createVNode("input", {
                required: "",
                type: "email",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.forgotEmail = $event)),
                class: "form-control",
                placeholder: "Type email"
              }, null, 512), [
                [_vModelText, $setup.forgotEmail]
              ]),
              _createVNode("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
              ])
            ]),
            _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('login.resetPassword')), 1)
          ], 32)),
      _createVNode("img", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.forgotPassword = false)),
        src: _imports_0,
        class: "login-registration-logo"
      })
    ])
  ], 64))
})